
export const mockData = [
  {
    'id': 1,
    'first_name': 'Chrisse',
    'last_name': 'Perceval',
    'email': 'cperceval0@berkeley.edu',
    'birth_date': '1/23/2023',
    'gender': 'Male',
    'catch_phrase': 'Cross-group scalable productivity'
  }, {
    'id': 2,
    'first_name': 'Garrik',
    'last_name': 'Zealey',
    'email': 'gzealey1@cnn.com',
    'birth_date': '8/16/2022',
    'gender': 'Male',
    'catch_phrase': 'Universal high-level circuit'
  }, {
    'id': 3,
    'first_name': 'Ansel',
    'last_name': 'Monelli',
    'email': 'amonelli2@arizona.edu',
    'birth_date': '3/8/2022',
    'gender': 'Male',
    'catch_phrase': 'Configurable stable frame'
  }, {
    'id': 4,
    'first_name': 'Horten',
    'last_name': 'Durden',
    'email': 'hdurden3@wikispaces.com',
    'birth_date': '5/29/2022',
    'gender': 'Male',
    'catch_phrase': 'Synergistic local function'
  }, {
    'id': 5,
    'first_name': 'Paxon',
    'last_name': 'Revening',
    'email': 'prevening4@hostgator.com',
    'birth_date': '7/27/2022',
    'gender': 'Male',
    'catch_phrase': 'Innovative zero tolerance utilisation'
  }
];
export const columns = [
  { 'field': 'first_name', 'headerName': 'Imię' },
  { 'field': 'last_name', 'headerName': 'Nazwisko' },
  { 'field': 'email', 'headerName': 'Email' },
  { 'field': 'gender', 'headerName': 'Płeć' },
  { 'field': 'birth_date', 'headerName': 'Data urodzenia' },
  { 'field': 'catch_phrase', 'headerName': 'Catch phrase' }
];
